import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_approval_sequence_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  prev_guid: fromDatatype.GuidDataFieldInterface;
  next_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  submitter_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  submitter_name: fromDatatype.VarcharDatatypeInterface;
  approval_sequence: fromDatatype.IntegerDatatypeInterface;
  approver_guid: fromDatatype.GuidDataFieldInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  is_delegated_approval: boolean;
  delegating_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegating_approver_name: fromDatatype.VarcharDatatypeInterface;
  approval_date: fromDatatype.TimestampTzDatatypeInterface;
  is_first_approval_level: boolean;
  total_required_approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_quorum: fromDatatype.IntegerDatatypeInterface;
  approval_logic: fromDatatype.VarcharDatatypeInterface;
  approval_level_count: fromDatatype.IntegerDatatypeInterface;
  approval_quorum_count: fromDatatype.IntegerDatatypeInterface;
  approver_designation: fromDatatype.VarcharDatatypeInterface;
  max_approval_amount: fromDatatype.NumericDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  is_approver: boolean;
  remarks: fromDatatype.TextDatatypeInterface;
  approval_request_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_request_queue_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;  
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_approval_sequence_RowClass implements bl_fi_generic_doc_approval_sequence_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  prev_guid: fromDatatype.GuidDataFieldInterface;
  next_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  submitter_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  submitter_name: fromDatatype.VarcharDatatypeInterface;
  approval_sequence: fromDatatype.IntegerDatatypeInterface;
  approver_guid: fromDatatype.GuidDataFieldInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  is_delegated_approval: boolean;
  delegating_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegating_approver_name: fromDatatype.VarcharDatatypeInterface;
  approval_date: fromDatatype.TimestampTzDatatypeInterface;
  is_first_approval_level: boolean;
  total_required_approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_level: fromDatatype.IntegerDatatypeInterface;
  approval_quorum: fromDatatype.IntegerDatatypeInterface;
  approval_logic: fromDatatype.VarcharDatatypeInterface;
  approval_level_count: fromDatatype.IntegerDatatypeInterface;
  approval_quorum_count: fromDatatype.IntegerDatatypeInterface;
  approver_designation: fromDatatype.VarcharDatatypeInterface;
  max_approval_amount: fromDatatype.NumericDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  is_approver: boolean;
  remarks: fromDatatype.TextDatatypeInterface;
  approval_request_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_request_queue_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;  
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
